import { Injectable } from '@angular/core';
import { EntityCollectionServiceBase, EntityCollectionServiceElementsFactory } from '@ngrx/data';
import { GeographicalRegions } from '../../party/model/geographicalRegions.model';

@Injectable({
    providedIn: 'root'
})
export class GeographicalEntityService extends EntityCollectionServiceBase<GeographicalRegions> {
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory) {
        super('Geographical', serviceElementsFactory);
    }
}
